






import Vue from 'vue';

export default Vue.extend({
  name: "BeachMain2d",
  data: () => {
    return {};
  },
});
